import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { GOOGLE_SHEET_AUTH_LINK } from '../../../constants';
import { editFormSettings } from '../../../store/actions/formActions';
import { Button, message } from 'antd';

const GoogleSheetModal = ({ form }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const isConnected =
    form.integrations?.gsheet?.accessToken && form.integrations?.gsheet?.refreshToken;

  const gsheet = form.integrations?.gsheet;

  const handleConnect = async () => {
    setLoading(true);
    try {
      const {
        data: { url },
      } = await axios(GOOGLE_SHEET_AUTH_LINK, {
        params: {
          formId: form.id,
        },
      });
      window.location = url;
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const handleDisconnect = async () => {
    try {
      setLoading(true);
      const event = await dispatch(
        editFormSettings(form.id, {
          whatsappNumber: form.whatsappNumber, // To jump validation
          integrations: { ...form.integrations, gsheet: {} },
        }),
      );
      if (event && event.type === 'EDIT_FORM_FAIL') {
        throw Error();
      }
    } catch (e) {
      console.log(e);
      message.error(t('formSettings.disconnectFailed'));
    } finally {
      setLoading(false);
    }
  };

  let buttons = [
    <Button
      key="connect"
      type="secondary"
      onClick={handleConnect}
      loading={loading}
      className="integration-connect"
    >
      <img src="/google/g-logo.png" alt="google-logo" />
      {t('formSettings.connectwithgoogle')}
    </Button>,
  ];
  if (isConnected)
    buttons = [
      <Button key="open" type="primary" href={gsheet.spreadsheetUrl} target="_blank">
        {t('formSettings.gsheet.open', { title: 'Google Sheet' })}
      </Button>,
      <Button key="reset" danger loading={loading} onClick={handleDisconnect} disabled={loading}>
        {t('formSettings.disconnect')}
      </Button>,
    ];

  return <div className="gsheet-integration-card-content">{buttons}</div>;
};

export default GoogleSheetModal;
